const repeatTypes = [
    "NO-REPEAT",
    "REPEAT-X",
    "REPEAT-Y",
    "REPEAT",
    "SPACE",
    "ROUND",
] as const;

type RepeatType = (typeof repeatTypes)[number];

export { repeatTypes };
export type { RepeatType };
